import { FORM, FORM_STATUS } from 'src/constants/Form';
import { Store } from 'src/redux/Store';

export const isQueryBuilderLoading = (state: Store): boolean => {
  const status = state.formStatus[FORM.query_builder];
  return status === undefined || status === FORM_STATUS.loading;
};
